import * as Sentry from "@sentry/vue"

export function initSentry(app, router) {
  Sentry.init({
    app,
    dsn: "https://8eecd44bd9102f0b5936f4997785ddbb@o4508438537175040.ingest.de.sentry.io/4510272452493392",
    enabled: process.env.NODE_ENV === 'production',

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/stapvoorstapregie\.nl\/api/],
  });
}
